import { render, staticRenderFns } from "./MapsReplacer.vue?vue&type=template&id=3f5a9cec"
import script from "./MapsReplacer.vue?vue&type=script&lang=ts"
export * from "./MapsReplacer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports